export const Sticker = ({ children, color = "yellow", rotate = 0, className = "", icon, ...rest }) => (
  <span className={`sticker sticker-${color} ${className}`} style={{ "--r": `${rotate}deg` }} {...rest}>
    {icon}
    {children}
  </span>
);

export const Tape = ({ className = "", rotate = -5, color = "" }) => (
  <span className={`tape ${color ? `tape-${color}` : ""} ${className}`} style={{ "--r": `${rotate}deg` }} aria-hidden />
);

export const HandNote = ({ children, className = "", ...rest }) => (
  <span className={`font-hand text-[var(--ink-60)] ${className}`} {...rest}>
    {children}
  </span>
);

export const Arrow = ({ className = "", flip = false }) => (
  <svg viewBox="0 0 120 60" className={className} fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" aria-hidden
    style={{ transform: flip ? "scaleX(-1)" : undefined }}>
    <path d="M4 30 C 30 10, 70 50, 110 22" />
    <path d="M98 14 L 112 22 L 100 32" />
  </svg>
);

export const Scribble = ({ color = "var(--yellow)", className = "" }) => (
  <svg className={`scribble ${className}`} viewBox="0 0 200 12" preserveAspectRatio="none" aria-hidden>
    <path d="M2 8 C 40 2, 80 12, 120 6 S 180 2, 198 8" stroke={color} strokeWidth="5" fill="none" strokeLinecap="round" />
  </svg>
);
